import React from "react";
const FeatureCard = ({ icon, title, description, alt }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="w-10 h-10 bg-[#e0e7ff] rounded-md flex items-center justify-center mb-4">
        <img src={icon} alt={alt} className="w-5 h-5" />
      </div>
      <h3 className="font-bold text-lg mb-2">{title}</h3>
      <p className="text-[#475569] text-md leading-relaxed">{description}</p>
    </div>
  );
};

const features = [
  {
    icon: "https://storage.googleapis.com/a1aa/image/3c82bbea-9863-4625-96d0-91dc9bc9a18e.jpg",
    alt: "Icon of an open book representing Smart Planning",
    title: "Smart Planning",
    description:
      "Create and manage lesson plans, assignments, and assessments with AI assistance",
  },
  {
    icon: "https://storage.googleapis.com/a1aa/image/a1760696-441a-4bbe-c3c8-96dea1ef03d7.jpg",
    alt: "Icon of a bar chart representing Intelligent Analytics",
    title: "Intelligent Analytics",
    description:
      "Track performance, identify trends, and make data-driven decisions",
  },
  {
    icon: "https://storage.googleapis.com/a1aa/image/4cfe2156-e7ba-47fd-b199-488b04defd59.jpg",
    alt: "Icon of a brain representing Differentiated Learning",
    title: "Differentiated Learning",
    description:
      "Automatically adjust content and pacing to meet individual student needs",
  },
  {
    icon: "https://storage.googleapis.com/a1aa/image/f15bda4a-bac4-4216-f361-0635ac0ee246.jpg",
    alt: "Icon of two people representing Community Connection",
    title: "Community Connection",
    description:
      "Build stronger relationships between school and home with seamless communication",
  },
  {
    icon: "https://storage.googleapis.com/a1aa/image/873d165f-24ba-4ef2-c7f5-b43d6d07e45a.jpg",
    alt: "Icon of a compass arrow representing Site Navigation with AI",
    title: "Site Navigation with AI",
    description:
      "Our AI-driven page navigation transforms how users interact with the platform",
  },
  {
    icon: "https://storage.googleapis.com/a1aa/image/9b80f427-2097-4726-1fa1-9e09df13cd92.jpg",
    alt: "Icon of a light bulb representing Individualized Education Plans",
    title: "Individualized Education Plans",
    description:
      "Transform special education with AI-powered IEPs that dynamically adapt to student needs, tracking progress and suggesting interventions while ensuring compliance.",
  },
];

const Features = () => {
  return (
    <div className="bg-gradient-to-r from-[#e9efff] via-[#f7f5f7] to-[#f7f5f7] min-h-screen ">
      <main className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-16 ">
        <div className="text-center max-w-xl mx-auto mb-12">
          <h2 className="font-extrabold text-xl sm:text-2xl md:text-3xl leading-tight">
            Powerful Features for Modern Education
          </h2>
          <p className="mt-2 text-[#475569] text-sm sm:text-base leading-relaxed">
            Discover how our AI-powered platform transforms the educational
            experience
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <FeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              alt={feature.alt}
            />
          ))}
        </div>
      </main>
    </div>
  );
};

export default Features;